<template id="tab">
  <div v-bind:class="[{'active': active}, 'tab', 'segment']">

    <slot></slot>
  </div>
</template>

<script>

export default { 

  data: function() {
    return {
      active: false
    };
  },

  props: {
    title: {
      required: true,
      type: String
    },
    isActive: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  methods: {
    removeTab: function() {
      this.$destroy();
    }
  },

  created: function() {
    this.active = this.isActive;
  },

  mounted: function() {
    this.$parent.addTab(this);
  },

  watch: {
    //isActive: function(){}
  }
}
</script>

<style>
		.segment {
			display:none;
		}
		
		.active
			{
			  display:inline;
			}


		

</style>


// WEBPACK FOOTER //
// client/components/Catalog/CatalogTab.vue